import { format as dateFormat, isAfter } from 'date-fns'
import { createColumnHelper } from '@tanstack/react-table'

export const columnHelper = createColumnHelper<APIPaymentSubscription>()

export const getFrequency = (subscription: APIPaymentSubscription) => {
  const { interval, interval_count } = subscription

  const isSingle = interval_count === 1
  const count = isSingle ? '' : `${interval_count} `
  const suffix = isSingle ? '' : 's'

  return `every ${count}${interval}${suffix}`
}

export const getDate = (subscription: APIPaymentSubscription) => {
  const { trial_end, renewal_date } = subscription

  const now = new Date()
  const format = 'EEE, MMM d yyyy'

  if (trial_end) {
    const trialEnd = new Date(trial_end)
    if (isAfter(trialEnd, now)) {
      const formatted = dateFormat(trialEnd, format)
      return `Trial ends ${formatted}`
    }
  }

  if (renewal_date) {
    const renewalDate = new Date(renewal_date)
    const formatted = dateFormat(renewalDate, format)
    const prefix = isAfter(renewalDate, now) ? 'Renews on' : 'Expired'
    return `${prefix} ${formatted}`
  }

  return ''
}
